import {Selector} from '@ngxs/store';
import {LocationAutocompleteState, LocationAutocompleteStateModel} from './location-autocomplete.state';
import {LocationPlaceResult} from '../domains/location-place-result';

export class LocationAutocompleteSelector {

  @Selector([LocationAutocompleteState])
  static loading(state: LocationAutocompleteStateModel): boolean {
    return state.loading;
  }

  @Selector([LocationAutocompleteState])
  static getLocations(state: LocationAutocompleteStateModel): LocationPlaceResult[] {
    return state.locations;
  }
}
